import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { useNavigate } from "@opendash/router";
import { Tooltip } from "antd";
import React from "react";
import { useTicketData } from "../..";
import { TicketUpdateBadge } from "./details/TicketUpdateBadge";

type Props = {};

export const TicketLink = (props: Props) => {
  const t = useTranslation();
  const navigate = useNavigate();
  const ticketData = useTicketData();

  return (
    <TicketUpdateBadge>
      <Tooltip title={t("maintenance:ticket.edit.link")}>
        <Icon
          cursor="pointer"
          icon="fa:search"
          key="edit"
          onClick={() =>
            navigate("/openservice/ticket/" + ticketData?.ticket?.id)
          }
        />
      </Tooltip>
    </TicketUpdateBadge>
  );
};
